import { render, staticRenderFns } from "./TechFeatures.vue?vue&type=template&id=893ff276&"
import script from "./TechFeatures.vue?vue&type=script&lang=js&"
export * from "./TechFeatures.vue?vue&type=script&lang=js&"
import style0 from "./TechFeatures.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports